export default __webpack_public_path__ + "static/media/SourceHanSansCN-Regular.be37d606.otf";